import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { RefreshCw } from 'lucide-react';
import { apiClient } from '../../utils/apiHelper';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CashBalance = () => {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchBalance(); }, []);

  const fetchBalance = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get('/api/accounts/cash-balance'); setBalance(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Cash Balance</CardTitle>
          <Button onClick={fetchBalance} disabled={loading}>
            <RefreshCw className="w-4 h-4 mr-2" />
            {loading ? 'Refreshing...' : 'Refresh'}
          </Button>
        </CardHeader>
        <CardContent>
          {balance && (
            <div className="space-y-4">
              <div className="p-6 bg-gradient-to-r from-green-50 to-green-100 rounded-lg">
                <p className="text-sm text-gray-600 mb-2">Current Cash Balance</p>
                <p className="text-4xl font-bold text-green-600">₹{balance.balance.toFixed(2)}</p>
                <p className="text-sm text-gray-500 mt-2">Last Updated: {new Date(balance.last_updated).toLocaleString('en-IN')}</p>
              </div>
              <div className="text-sm text-gray-600">
                <p>* This balance is calculated from all cash transactions (Income - Expenses)</p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CashBalance;